<template>
  <div>
    <div class="plan">
      <trip-left ref="tripLeft"></trip-left>
      <trip-right></trip-right>
    </div>
    <main-right-popup ref="rightPopup"></main-right-popup>
  </div>
</template>

<script>
import TripLeft from './leftMoudle/tripLeft.vue';
import mainRightPopup from './rightPopup/mainRightPopup.vue';
import TripRight from './rightPopup/tripRight.vue';
export default{
  components: { mainRightPopup, TripLeft, TripRight },
  mounted(){
  }
}
</script>

<style>

</style>